import { PropsWithChildren } from 'react';

import { AppBar } from '@mui/material';
import { ZfBox } from '@zafire/react';
import theme from 'theme';
import { useHost } from 'contexts/Host';

const topBarStyles = {
  paddingLeft: theme.spacing(3),
};

const SecondNavigationBar = ({ children }: PropsWithChildren) => {
  const { isWena } = useHost();

  if (isWena) {
    return <ZfBox styles={{ paddingLeft: 'xl', paddingRight: 'xl' }}>{children}</ZfBox>;
  }

  return (
    <AppBar position="static" color="secondary" elevation={0} sx={topBarStyles}>
      {children}
    </AppBar>
  );
};

export default SecondNavigationBar;
